import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card-holder loading-holder"
}
const _hoisted_2 = {
  key: 1,
  class: "card-holder"
}

import { computed } from "vue";
import AssessmentCard from "@/components/Assessment/AssessmentCard/AssessmentCard.vue";
import "swiper/css";
import { SanityAssessment, useAssessmentStore } from "@/store";
import { RouterLink } from "vue-router";
import { parseImageUrl } from "@/helpers";
import CardSkeleton from "@/components/Skeletons/CardSkeleton/CardSkeleton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'AssessmentCards',
  setup(__props) {

const assessmentStore = useAssessmentStore();

const isAssessmentsLoaded = computed(() => assessmentStore.isAssessmentsLoaded);
const assessmentsExist = computed(
  () => assessmentStore.getAssessments.length > 0
);
const assessments = computed<Array<SanityAssessment>>(
  () => assessmentStore.getAssessments
);

const parseFeatureImage = (image: any) => {
  return parseImageUrl(image, 300, 300) || undefined;
};

return (_ctx: any,_cache: any) => {
  return (!isAssessmentsLoaded.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(2, (index) => {
          return _createVNode(CardSkeleton, {
            class: "assessment-card",
            key: index
          })
        }), 64))
      ]))
    : (assessmentsExist.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(assessments.value, (item) => {
            return (_openBlock(), _createBlock(_unref(RouterLink), {
              to: {
        name: 'AssessmentDetail',
        params: { id: item.baseId },
      },
              key: item.id,
              class: "card-wrapper",
              "data-test": "router-link"
            }, {
              default: _withCtx(() => [
                _createVNode(AssessmentCard, {
                  "data-test": "card-holder-assessment",
                  class: "assessment-card",
                  assessment: item,
                  thumbnail: parseFeatureImage(item.featureImage),
                  placeholderImg: require('@/assets/course-thumbnail-placeholder.png')
                }, null, 8, ["assessment", "thumbnail", "placeholderImg"])
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ]))
      : _createCommentVNode("", true)
}
}

})